"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (pluginName, propsFactory) {
  var nameMapper = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (name) {
    return name;
  };
  var shouldProvide = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (component) {
    return true;
  };

  var props, vpoWrapperUpdate;
  if (typeof propsFactory !== 'function') {
    return console.error("You must provide props factory");
  }
  props = propsFactory();
  vpoWrapperUpdate = function vpoWrapperUpdate() {
    var name, results;
    results = [];
    for (name in props) {
      results.push(this["$__vpo__" + pluginName].wrapper[name] = this[nameMapper(name)]);
    }
    return results;
  };
  return {
    provide: function provide() {
      var provide, ref, vue;
      if (!shouldProvide(this)) {
        return {};
      }
      vue = ((ref = this.$root.$vpo) != null ? ref.Vue : void 0) || Object.getPrototypeOf(this.$root).constructor;
      provide = _defineProperty({}, "" + pluginName, {
        wrapper: {}
      });
      provide[pluginName].wrapper = vue.observable(propsFactory());
      this["$__vpo__" + pluginName] = {
        wrapper: provide[pluginName].wrapper,
        watchers: []
      };
      return provide;
    },
    created: function created() {
      var _this = this;

      if (!shouldProvide(this)) {
        return;
      }
      this["$__vpo__" + pluginName].watchers = Object.keys(props).map(function (name) {
        // TO DO: optimize
        return _this.$watch(nameMapper(name), vpoWrapperUpdate.bind(_this));
      });
      return vpoWrapperUpdate.call(this);
    },
    beforeDestroy: function beforeDestroy() {
      if (!shouldProvide(this)) {
        return;
      }
      return this["$__vpo__" + pluginName].watchers.forEach(function (unwatch) {
        return unwatch();
      });
    },
    updated: function updated() {
      if (!shouldProvide(this)) {
        return;
      }
      return vpoWrapperUpdate.call(this);
    }
  };
};

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// props is the hash with name => value
var installer = exports.installer = {
  install: function install(Vue, options) {
    if (Vue.prototype.$vpo) {
      return;
    }
    Vue.prototype.$vpo = {};
    return Vue.prototype.$vpo.Vue = Vue;
  }
};

;

